import { Spinner } from 'components/atoms/Spinner/Spinner'
export function Loading() {
  return (
    <div className='pt-2'>
      <Spinner />
    </div>
  )
}
